import React from "react";
import "../../Subscription.css";

const SubscriptionDescription = ({ subscriptionSource }) => {
	const isStripe = subscriptionSource === "stripe";

	return (
		<div className="subscription-section">
			<div className="subscription-description">
				<p>
					The host count sets the monthly price. <strong>The minimum is 3 hosts.</strong>{" "}
					{isStripe
						? "Card subscriptions bill through Stripe."
						: subscriptionSource === "paypal"
							? "This account bills through PayPal."
							: "New subscriptions can be paid by card or PayPal."}
				</p>

				<div className="subscription-description-example">
					<h4>Example: 5 hosts</h4>
					<p>
						<strong>3 × $29 + 2 × $20 = $127</strong> per month
					</p>
				</div>

				<h3>Adding a host</h3>
				{isStripe ? (
					<p>
						The new monthly price starts immediately. Stripe charges only the prorated difference for the days left in this billing period, then the full new price on the next renewal.
					</p>
				) : (
					<p>
						PayPal asks you to approve the new host count. That approval has to stay inside the same PayPal price tier. Moving from 3 hosts to 4 hosts crosses a tier, and PayPal will reject it.
					</p>
				)}

				<h3>Removing a host</h3>
				<p>
					{isStripe
						? "You keep the current host count until the renewal date. The lower price starts on that date, and nothing is charged today. Remove extra hosts before the renewal if you still have more hosts than the new count."
						: "Lowering the count keeps your current hosts until the next PayPal cycle, as long as the new count stays in the same price tier and you don't have more hosts than the new count."}
				</p>
			</div>
		</div>
	);
};

export default SubscriptionDescription;
